import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface ImportedInvoicePaymentSummaryContentProps {
  summaryColor: Color
}

export const ImportedInvoicePaymentSummaryContent = styled.div<ImportedInvoicePaymentSummaryContentProps>`
  padding: ${Spacing.S40} ${Spacing.S16} 0;
  background-color: ${({ summaryColor }) => summaryColor};
  text-align: center;
`

interface ImportedInvoicePaymentSummaryWaveWrapperProps {
  summaryColor: Color
}

/* The wave fills with `currentColor`, so one asset takes either status color. */
export const ImportedInvoicePaymentSummaryWaveWrapper = styled.div<ImportedInvoicePaymentSummaryWaveWrapperProps>`
  display: flex;
  color: ${({ summaryColor }) => summaryColor};
`
